import { Component } from 'components/folders-and-labels';

/** @ngInject */
export default function foldersAndLabelsRouter($stateProvider) {
    const baseState = {
        redirectTo: 'main.folders-and-labels.folders',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.folders-and-labels', baseState);
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders-and-labels.router.js